import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-activate",
  "use": "icon-activate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-activate\"><path d=\"M512 0a512 512 0 1 0 512 512A512 512 0 0 0 512 0z m247.389091 347.694545L642.792727 605.090909a69.818182 69.818182 0 0 1-34.676363 34.676364L346.763636 759.156364A46.545455 46.545455 0 0 1 284.625455 698.181818l114.26909-267.636363a69.818182 69.818182 0 0 1 37.701819-37.236364L698.181818 285.323636a46.545455 46.545455 0 0 1 60.043637 62.138182z\" p-id=\"4350\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol